<template>
    <div class="report-wrap">
        <div class="report-item report1">
            <p>告警信息</p>
            <small>{{alarm.alarm}}条</small>
        </div>
        <div class="report-item report2">
            <p>故障信息</p>
            <small>{{alarm.fault}} 条</small>
        </div>
    </div>
</template>

<script>
export default {
    name:"report",
    data(){
        return {
            alarm:{alarm:10,fault:10},
        }
    }
}
</script>

<style lang="scss">
.report-wrap{
    display: flex;
    width:100%;
    height: 100%;

    .report-item{
        flex: 1;
        text-align: center; 
    }

    .report1{
        background: url(./images/report01.png) center no-repeat;
    }
    .report2{
        background: url(./images/report02.png) center no-repeat;
        }
        
    .report-item p{ 
        font-weight: bold; 
        font-size: 18px; 
        color: #ff0000;
        top: 45%;
        position: relative;
        transform: translateY(-45%);
    }
    .report-item small{
        font-size: 24px;
        top: 45%;
        position: relative;
        transform: translateY(-45%);
    }
}
</style>